import { ApolloCache, RefetchQueriesOptions, useApolloClient } from '@apollo/client';

const fieldNames = [
  'profile',
  'workspace',
  'workspaceMembers',
  'workspaceVariables',
  'wizard',
  'organisation',
  'organisationMembers',
  'flatOrganisationsHome',
  'flatOrganisationsUser',
  'flatOrganisationsNav',
  'user',
  'assessments',
  'assessmentsScenarioNames',
  'assessmentsList',
  'assessment',
  'assessmentVariables',
  'assessmentRiskRegister',
  'incidents',
  'incidentsCheck',
  'incident',
  'incidentLinkedScenarios',
  'controls',
  'controlsRmpCheck',
  'controlsRmp',
  'assessmentScenariosWizard',
  'control',
  'controlLinkedScenarios',
  'scenario',
  'scenarioRmp',
  'scenarioControls',
  'events',
  'event',
  'controlFrameworkDetails',
  'complianceFramework',
  'filtersFor',
  'controlRmp',
  'controlModifier',
  'scenarioModifier',
  'scenarioIncidents',
  // AI Risk Assistant (ticket 7127) — used by the future GraphQL service to refetch the
  // session after a mutation; the current mock path does not touch the Apollo cache.
  'aiAssistantSession',
] as const;

export type KeyType = (typeof fieldNames)[number];

// Every surface a variable value feeds: the variables lists + the BE-recalculated
// control costs (CRPD-7222 recalcs on upsert AND delete). Variable-save paths on
// cost surfaces refetch with this ONE include array — never chain refetchQuery
// calls (see useCache.test.tsx, which pins the contents).
export const VARIABLE_SAVE_COST_INCLUDES: KeyType[] = [
  'workspaceVariables',
  'assessmentVariables',
  'controls',
  'control',
];

type RefetchQuery = (params?: {
  include?: KeyType[] | 'all';
  options?: RefetchQueriesOptions<ApolloCache<object>, unknown>;
}) => Promise<void>;

export const useCache = () => {
  const client = useApolloClient();

  const refetchQuery: RefetchQuery = async (params) => {
    const { include, options } = params || {};

    await client.refetchQueries({
      include,
      optimistic: false,
      ...options,
    });
  };

  return { refetchQuery };
};
